export class CreateUpdateApplicationSetting {
  settingKey: number;
  value: string;
  description: string;
}
